import React from "react";
import Home from "../../../components/Home/Home";

const Blank = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default Blank;
